import { Address } from 'utils/types';
import { DB_PREFIX } from './constants';

export default {
  [DB_PREFIX]: {
    ...Address,
  },
};
